import { render } from "./login.vue?vue&type=template&id=0904ed7f&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=0904ed7f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/admin.nikted.ir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0904ed7f"]])

export default __exports__